export default __webpack_public_path__ + "static/media/eillon.132e90d0.webp";